import React from 'react';
import { Link } from 'react-router-dom';
import { getBackgroundImageUrl } from 'hb-redux-store/util/miscellaneousServices';

const USPCard = ({ usp, last, pageType }) => (
  <div className={`desktop-usp-card   ${last ? 'last' : ''}`}>
    <Link to="#" title={usp.name}>
      <div
        className={`${
          pageType !== 'ProductDescription'
            ? 'desktop-usp-card--container'
            : 'desktop-usp-card--container-pdp'
        }`}
      >
        <div
          className="desktop-usp-card--usp-icon"
          style={getBackgroundImageUrl(usp.imagePath)}
        ></div>
        <div className="desktop-usp-card--usp-title">{usp.name}</div>
      </div>
    </Link>
  </div>
);

export default USPCard;
